module.exports = __webpack_public_path__ + "static/img/address.c3577f83.png";